<template>
  <div class="search">
    <!-- 自定义顶部搜索栏 -->
    <div class="search-header">
      <van-icon name="arrow-left" class="back-icon" @click="$router.go(-1)" />
      
      <div class="input-wrapper">
        <input 
          type="text" 
          v-model.trim="content" 
          class="search-input" 
          placeholder="请输入搜索关键词"
          @keydown.enter="searchFn(content)"
        />
      </div>

      <span class="action-btn" @click="searchFn(content)">搜索</span>
    </div>

    <!-- 搜索历史 -->
    <div class="search-history" v-if="searchHistory.length > 0">
      <div class="title">
        <span>最近搜索</span>
        <van-icon name="delete-o" size="16" @click="clearFn" />
      </div>
      <div class="list">
        <div
          class="list-item"
          v-for="(item, index) in searchHistory"
          :key="index + 'a'"
          @click="searchFn(item)"
        >{{ item }}</div>
      </div>
    </div>

    <!-- 底部导航占位 -->
    <div class="bottom-placeholder"></div>
  </div>
</template>

<script>
import { getLocalSearchHistory, setLocalSearchHistory } from '@/utils/storage'
import { Toast } from 'vant'

export default {
  name: 'Search',
  data () {
    return {
      content: '',
      searchHistory: []
    }
  },
  created () {
    this.searchHistory = getLocalSearchHistory()
  },
  methods: {
    searchFn (keywords) {
      if (!keywords) {
        Toast('请输入搜索关键词')
        return
      }
      const history = getLocalSearchHistory()
      const newHistory = [keywords, ...history.filter(item => item !== keywords)].slice(0, 10)
      setLocalSearchHistory(newHistory)
      this.searchHistory = newHistory
      
      this.$router.push({
        path: '/searchlist',
        query: { goodsName: keywords }
      })
    },
    clearFn () {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '确定清空搜索历史吗？'
      })
        .then(() => {
          setLocalSearchHistory([])
          this.searchHistory = []
          this.$toast('已清空')
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  background-color: #f7f7f7;
  min-height: 100vh;
  padding-bottom: 60px; /* 给底部导航留空间 */

  .search-header {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #ffffff;
    width: 100%;
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 100;

    .back-icon {
      font-size: 24px;
      color: #333;
      cursor: pointer;
      padding-right: 12px;
    }

    .input-wrapper {
      flex: 1;
      margin-right: 12px;

      .search-input {
        width: 100%;
        height: 36px;
        background-color: #f2f2f2;
        border: none;
        border-radius: 8px;
        padding: 0 15px;
        font-size: 15px;
        outline: none;
        box-sizing: border-box;
        color: #333;

        &::placeholder {
          color: #999;
        }
        
        &:focus {
          background-color: #ebebeb;
        }
      }
    }

    .action-btn {
      color: #b24a40;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      white-space: nowrap;
      
      &:active {
        opacity: 0.7;
      }
    }
  }

  .search-history {
    margin-top: 10px;

    .title {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      background-color: #fff;
    }

    .list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 10px 10px 0;
      gap: 3%;
      background-color: #fff;

      .list-item {
        width: 30%;
        text-align: center;
        padding: 8px 0;
        line-height: 15px;
        border-radius: 50px;
        background: #f7f7f7;
        font-size: 13px;
        color: #666;
        border: 1px solid #efefef;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
        cursor: pointer;
        
        &:active {
          background-color: #efefef;
        }
      }
    }
  }

  /* 底部导航占位 */
  .bottom-placeholder {
    height: 50px;
  }
}
</style>